import { useAuth0 } from '@auth0/auth0-react';

// Auth0 sets a custom claim on the ID token for the user's global roles. The
// Rule/Action that adds it uses an HTTPS-style namespace; we also fall back
// to the colon-style variant other Auth0 setups use, so the check stays
// useful if the tenant ever migrates the claim shape.
const ROLE_CLAIM_KEYS = [
    'https://fortius-app.com/roles',
    'fortius-app:roles',
] as const;

const FORTIUS_ADMIN_ROLE = 'superadmin';

export const hasFortiusAdminRole = (user: Record<string, unknown> | undefined): boolean => {
    if (!user) return false;
    for (const key of ROLE_CLAIM_KEYS) {
        const value = user[key];
        if (Array.isArray(value) && value.some(r => typeof r === 'string' && r === FORTIUS_ADMIN_ROLE)) {
            return true;
        }
    }
    return false;
};

// Cross-tenant role check. Reads the Auth0 ID-token role claim — independent
// of per-tenant /auth/sync permissions, so it stays true even when the
// currently-selected tenant is broken or the user isn't a member of it.
export const useIsFortiusAdmin = (): boolean => {
    const { user } = useAuth0();
    return hasFortiusAdminRole(user as Record<string, unknown> | undefined);
};
